import React, { useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faBell,
  faRightFromBracket,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import "./AppHeader.css";

import routes from "../../routes";
import LogoutConfirmationModal from "../../components/header/logout/logoutConfirmationModal/LogoutConfirmationModal";

const AppHeader = ({ onMenuClick = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Modal Visibility States
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Logout process visibility
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Page title from the route table (most specific match wins)
  const pageTitle = useMemo(() => {
    const match = [...routes]
      .sort((a, b) => b.path.length - a.path.length)
      .find((route) =>
        matchPath({ path: route.path, end: false }, location.pathname),
      );
    return match?.name === "Home" ? "Dashboard" : match?.name || "Dashboard";
  }, [location.pathname]);

  const today = new Date().toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  // Open Logout Confirmation Modal
  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };
  // Close Logout Confirmation Modal
  const handleLogoutModalClose = () => {
    setShowLogoutModal(false);
  };
  // Proceed with Logout
  const handleLogoutProceed = () => {
    // Close confirmation modal
    setShowLogoutModal(false);

    // Show logout process
    setIsLoggingOut(true);

    // Clear login/session data
    localStorage.clear();
    sessionStorage.clear();
    setTimeout(() => {
      navigate("/");
    }, 2000);
  };

  return (
    <>
      <header className="app-header">
        <div className="header-left">
          <button
            type="button"
            className="menu-btn"
            onClick={onMenuClick}
            aria-label="Open menu"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>

          <div className="title-block">
            <h1 className="page-title">{pageTitle}</h1>
            <p className="page-date">{today}</p>
          </div>
        </div>

        {/* Right Actions Section */}
        <div className="header-right">
          <Link
            to="/notification"
            className="icon-btn"
            title="Notifications"
            aria-label="Notifications"
          >
            <FontAwesomeIcon icon={faBell} />
          </Link>

          <Link
            to="/profile"
            className="profile-chip"
            title="Profile"
            aria-label="Profile"
          >
            <span className="avatar">
              <FontAwesomeIcon icon={faUser} />
            </span>
            <span className="profile-text">My Profile</span>
          </Link>

          <button
            className="icon-btn logout-btn"
            type="button"
            title="Logout"
            aria-label="Logout"
            onClick={handleLogoutClick}
          >
            <FontAwesomeIcon icon={faRightFromBracket} />
          </button>
        </div>
      </header>

      {/* Modal 1: Logout Confirmation */}
      <LogoutConfirmationModal
        show={showLogoutModal}
        onHide={handleLogoutModalClose}
        onButtonClick={handleLogoutProceed}
      />

      {isLoggingOut && (
        <div className="logout-overlay" role="status" aria-live="polite">
          <div className="logout-card">
            <Spinner animation="border" className="logout-spinner" />
            <p>Signing you out…</p>
          </div>
        </div>
      )}
    </>
  );
};

export default AppHeader;
